import {
    Button,
    Checkbox,
    FormControl, FormLabel,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Textarea,
    useToast
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { fetchAllCouriers } from "../../api";

const SendPushNotification = ({ isOpen, onClose }) => {
    const [couriers, setCouriers] = useState([]);
    const [formData, setFormData] = useState({
        courierIds: [],
        message: "",
        priority: "normal",
        toAll: false
    });
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    useEffect(() => {
        fetchCouriers();
    }, []);

    const fetchCouriers = async () => {
        try {
            const response = await fetchAllCouriers(1, 999);
            if (response.success) {
                const options = response.data.couriers.map(c => ({
                    label: c.name,
                    value: c._id
                }));
                setCouriers(options);
            }
        } catch {
            toast({ title: "Error loading couriers", status: "error" });
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        const payload = {
            courierIds: formData.toAll ? "ALL" : formData.courierIds.map(c => c.value),
            message: formData.message,
            priority: formData.priority
        };
        console.log("Sending:", payload);
        // Your sending logic here
        setLoading(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Send Notification</ModalHeader>
                <ModalBody>

                    <FormControl mb={3}>
                        <Checkbox
                            isChecked={formData.toAll}
                            onChange={(e) => {
                                setFormData({ ...formData, toAll: e.target.checked, courierIds: [] });
                            }}
                        >
                            Send to All Couriers
                        </Checkbox>
                    </FormControl>

                    <FormControl isDisabled={formData.toAll}>
                        <FormLabel>Select Couriers</FormLabel>
                        <Select
                            isMulti
                            options={couriers}
                            value={formData.courierIds}
                            closeMenuOnSelect={false}
                            onChange={(selected) => setFormData({ ...formData, courierIds: selected })}
                        />
                    </FormControl>

                    <FormControl mt={3} isRequired>
                        <FormLabel>Message</FormLabel>
                        <Textarea
                            value={formData.message}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            placeholder="Type your message..."
                        />
                    </FormControl>

                    <FormControl mt={3}>
                        <FormLabel>Priority</FormLabel>
                        <Select
                            value={{ label: formData.priority, value: formData.priority }}
                            onChange={(option) => setFormData({ ...formData, priority: option.value })}
                            options={[
                                { label: "Normal", value: "normal" },
                                { label: "Urgent", value: "urgent" }
                            ]}
                        />
                    </FormControl>

                </ModalBody>

                <ModalFooter>
                    <Button onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>Send</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default SendPushNotification;
